import React from "react";
import Modal from "@mui/material/Modal";
import { RxCross1 } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const PlantRankingModal = ({ open, onClose, rowData, onSuccess }) => {
  const formik = useFormik({
    initialValues: {
      metricId: rowData?.metrc_id || "",
      bucketId: rowData?.bucket_id || "",
      overallGrowth: "",
    },
    validationSchema: Yup.object({
      overallGrowth: Yup.number()
        .required("Overall Growth is required")
        .typeError("Overall Growth must be a number"),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (onSuccess) {
          onSuccess(rowData.id, values.overallGrowth);
        }
        toast.success("Plant ranking assigned successfully", {
          position: "top-right",
        });
        handleClose();
      } catch (error) {
        console.error("Error assigning plant ranking:", error);
        toast.error("Failed to assign plant ranking", {
          position: "top-right",
        });
      }
    },
  });

  const handleClose = () => {
    formik.resetForm();
    if (onClose) onClose();
  };

  return (
    <Modal
      className="department-modal"
      open={open}
      onClose={handleClose}
      aria-labelledby="plant-ranking-modal-title"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal_block">
          <div className="modal_header">
            <div className="modal_title_wrapper">
              <h2 className="modal_title">Plant ranking</h2>
            </div>
            <div className="cancel-btn-wrap">
              <RxCross1 onClick={handleClose} />
            </div>
          </div>
          <div className="modal_content">
            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <div className="form_field_wrapper mb-0">
                  <label>Metric ID:</label>
                </div>
              </div>
              <div className="col-md-9">
                <span>{formik.values.metricId}</span>
              </div>
            </div>
            <div className="row align-items-center mb-3">
              <div className="col-md-3">
                <div className="form_field_wrapper mb-0">
                  <label>Bucket ID:</label>
                </div>
              </div>
              <div className="col-md-9">
                <span>{formik.values.bucketId}</span>
              </div>
            </div>
            <div className="row align-items-center mb-3">
              <div className="col-md-12">
                <div className="form_field_wrapper mb-0">
                  <label>Overall Growth<span style={{ color: "red" }}>*</span></label>
                </div>
              </div>
              <div className="col-md-12">
                <input
                  type="text"
                  name="overallGrowth"
                  value={formik.values.overallGrowth}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`form-control ${
                    formik.touched.overallGrowth && formik.errors.overallGrowth
                      ? "is-invalid"
                      : ""
                  }`}
                />
                {formik.touched.overallGrowth && formik.errors.overallGrowth && (
                  <div className="invalid-feedback">
                    {formik.errors.overallGrowth}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button type="button" onClick={handleClose} className="btn btn-border">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Assign
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default PlantRankingModal;